export default __webpack_public_path__ + "static/media/youtubeLogo.00d70ea0.svg";